import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { Sun, Plus, Trash2, Loader2, MapPin, Zap } from "lucide-react";
import { toast } from "sonner";

export default function Progetti3D() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/solar/projects");
      setProjects(data || []);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const del = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm("Eliminare questo progetto?")) return;
    try {
      await api.delete(`/solar/projects/${id}`);
      setProjects((p) => p.filter((x) => x.id !== id));
      toast.success("Progetto eliminato");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div data-testid="progetti-3d-page">
      <div className="flex items-start justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest mb-2" style={{ color: "var(--primary)" }}>
            <Sun className="w-3.5 h-3.5" /> Progettazione FV
          </div>
          <h1 className="text-3xl font-extrabold tracking-tight" style={{ fontFamily: "Manrope" }}>Progetti FV</h1>
          <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>Progettazione impianti da immagine satellitare (Google Solar) con stima produzione.</p>
        </div>
        <button onClick={() => navigate("/progetti-3d/nuovo")} className="btn-primary" data-testid="new-project-btn">
          <Plus className="w-4 h-4" /> Nuovo progetto
        </button>
      </div>

      {loading ? (
        <div className="card-shell p-8 flex items-center justify-center text-sm"><Loader2 className="w-4 h-4 animate-spin mr-2" /> Caricamento…</div>
      ) : projects.length === 0 ? (
        <div className="card-shell p-12 text-center" data-testid="progetti-empty">
          <Sun className="w-10 h-10 mx-auto mb-3" style={{ color: "var(--primary)" }} />
          <div className="text-sm" style={{ color: "var(--text-muted)" }}>Nessun progetto. Crea il primo cliccando "Nuovo progetto".</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p) => (
            <div key={p.id} onClick={() => navigate(`/progetti-3d/${p.id}`)} className="card-shell p-4 cursor-pointer hover:shadow-lg transition-shadow" data-testid={`project-card-${p.id}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="font-bold truncate" style={{ fontFamily: "Manrope" }}>{p.name}</div>
                <button onClick={(e) => del(e, p.id)} className="p-1 rounded hover:bg-red-50" data-testid={`project-delete-${p.id}`}><Trash2 className="w-4 h-4 text-red-500" /></button>
              </div>
              {p.address && <div className="text-xs mt-1 flex items-center gap-1 truncate" style={{ color: "var(--text-muted)" }}><MapPin className="w-3 h-3" /> {p.address}</div>}
              <div className="mt-3 flex items-center gap-3 text-sm">
                {p.config?.kwp != null && <span className="inline-flex items-center gap-1 font-semibold" style={{ color: "var(--primary)" }}><Zap className="w-3.5 h-3.5" /> {p.config.kwp} kWp</span>}
                {p.config?.total_panels != null && <span style={{ color: "var(--text-muted)" }}>{p.config.total_panels} moduli</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
